module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loseCause"
  }, [_c('el-dialog', {
    attrs: {
      "title": "输单反馈",
      "visible": _vm.loseCauseShow,
      "modal-append-to-body": false,
      "before-close": _vm.close,
      "top": "22%"
    },
    on: {
      "update:visible": function($event) {
        _vm.loseCauseShow = $event
      }
    }
  }, [(_vm.flag) ? _c('div', {
    staticClass: "warn"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v("确认跳转到"), _c('span', {
    staticStyle: {
      "color": "#F28B47"
    }
  }, [_vm._v("输单")]), _vm._v("阶段吗？")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cause"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "选择输单原因（必填）"
    },
    model: {
      value: (_vm.curLoseCause),
      callback: function($$v) {
        _vm.curLoseCause = $$v
      },
      expression: "curLoseCause"
    }
  }, _vm._l((_vm.loseCauseArray), function(option) {
    return _c('el-option', {
      key: option.key,
      attrs: {
        "label": option.value,
        "value": option.key
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "textarea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "输单备注"
    },
    model: {
      value: (_vm.curLoseCauseMemo),
      callback: function($$v) {
        _vm.curLoseCauseMemo = $$v
      },
      expression: "curLoseCauseMemo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保 存")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23cb2088","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/opportunity/lose-cause.vue
// module id = 1235
// module chunks = 82